/** Narrowest gallery thumbnail in which the car is still recognisable. */
export const THUMBNAIL_MIN_WIDTH_PX = 104;
